import { InventoryTransaction } from "@prism/prism-shared";


export const calculateOutliarAdjustedInventoryTransactionSlope = (
    transactions: InventoryTransaction[],
    initialQuantity: number
): number => {
    const data = removeInventoryTransactionOutliars(transactions,initialQuantity);
   
    // Normalize x values by subtracting the first timestamp
    const baseTime = data[0].id;
    const normalizedData = structuredClone(data).map(point => ({
        x: (point.id - baseTime) / 1000, // Convert to seconds
        y: point.value
    }));

    // Calculate means
    const n = normalizedData.length;
    const meanX = normalizedData.reduce((sum, point) => sum + point.x, 0) / n;
    const meanY = normalizedData.reduce((sum, point) => sum + point.y, 0) / n;

    // Calculate slope using least squares method
    let numerator = 0;
    let denominator = 0;

    for (let i = 0; i < n; i++) {
        numerator += (normalizedData[i].x - meanX) * (normalizedData[i].y - meanY);
        denominator += Math.pow(normalizedData[i].x - meanX, 2);
    }
    return numerator / denominator;
}


export function removeInventoryTransactionOutliars(
    transactions: InventoryTransaction[],
    initialQuantity: number,
){
    const sortedTransactions = structuredClone(transactions).sort((a, b) => a.createdOn.getTime() - b.createdOn.getTime())
    const differences = [];
    for (let i = 1; i < sortedTransactions.length; i++) {
        const diff = sortedTransactions[i].createdOn.getTime() - sortedTransactions[i - 1].createdOn.getTime();
        differences.push(diff);
    }
    const sumMin = differences.reduce((sum, diff) => sum + diff, 0);
    const mean = sumMin / differences.length;
    const squaredDiffs = differences.map(diff => Math.pow(diff - mean, 2));
    const variance = squaredDiffs.reduce((sum, squared) => sum + squared, 0) / differences.length;
    const standardDeviation = Math.sqrt(variance);
    const upperBound = mean + standardDeviation;
    const filteredDifferencesMin = differences.filter(diff => diff < upperBound);
    const filteredSum = filteredDifferencesMin.reduce((sum, diff) => sum + diff, 0);
    const filteredMean = filteredSum / filteredDifferencesMin.length;

    const data = sortedTransactions.map((transaction, i) => {
        let outliar = false;
        let timestamp = transaction.createdOn.getTime();
        if (i !== 0) {
            let prevTimestamp = sortedTransactions[i - 1].createdOn.getTime();
            const diff = transaction.createdOn.getTime() - prevTimestamp;
            if (!filteredDifferencesMin.includes(diff)) {
                outliar = true;
                timestamp = prevTimestamp + filteredMean;
            }
        }
        let dataPointValue = initialQuantity;
        initialQuantity -= transaction.change;
        return {
            id: timestamp,
            value: dataPointValue,
            color: outliar ? 'var(--color-5)' : 'var(--color-text)',
        }
    })

    data.forEach((d, i) => {
        if (d?.color === 'var(--color-5)' && i !== (data.length - 1)) {
            const outliarDiff = data[i + 1].id - data[i].id
            const adjustedTimestamp = d.id + filteredMean;
            data[i + 1].id = adjustedTimestamp;
            for (let j = i + 1; j < (data.length - 1); j++) {
                data[j + 1].id -= (outliarDiff - filteredMean)
            }
        }
    })
    return data.map(d => ({
        ...d,
        value: d.value * -1
    })).reverse();
}